<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="1224">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents">
            <v-expansion-panels v-model="section" flat accordion>
                <template v-for="({ text, value }, index) in sections">
                    <v-expansion-panel :key="value">
                        <v-expansion-panel-header>
                            <v-row class="row--small page-text--lg font-weight-bold">
                                <v-col cols="auto">
                                    <span class="primary--active">{{ (index + 1).toString().padStart(2, 0) }}</span>
                                </v-col>
                                <v-col>
                                    {{ text }}
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <template v-if="value == RECRUITMENT_FORM_SECTIONS.BASEINFO.value">
                                <form-baseinfo :key="`${value}`" v-model="form" v-bind="{ hashTags }" @input="emit" />
                            </template>
                            <template v-if="value == RECRUITMENT_FORM_SECTIONS.EMPLOYMENT.value">
                                <form-employment :key="`${value}`" v-model="form" @input="emit" />
                            </template>
                            <template v-if="value == RECRUITMENT_FORM_SECTIONS.QUALIFICATION.value">
                                <form-qualification :key="`${value}`" v-model="form" @input="emit" />
                            </template>
                            <template v-if="value == RECRUITMENT_FORM_SECTIONS.RECRUITER.value">
                                <form-recruiter :key="`${value}`" v-model="form" @input="emit" />
                            </template>
                            <template v-if="value == RECRUITMENT_FORM_SECTIONS.QUESTIONS.value">
                                <form-questions :key="`${value}`" v-model="form.questions" @input="emit" />
                            </template>
                        </v-expansion-panel-content>
                        <v-divider class="my-10 my-lg-18" />
                    </v-expansion-panel>
                </template>
            </v-expansion-panels>
            <div class="v-btn-group flex-wrap">
                <form-preview :recruitment="form">
                    <template #activator="{ attrs, on }">
                        <v-btn v-bind="attrs" v-on="on" outlined color="grey-d" class="min-w-140px min-w-lg-160px"><span class="grey-6--text">미리보기</span></v-btn>
                    </template>
                </form-preview>
                <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="save"><span>저장하기</span></v-btn>
            </div>
            <!-- <v-card-actions class="justify-center">
                <form-preview :recruitment="form">
                    <template #activator="{ attrs, on }">
                        <v-btn outlined class="mr-10" v-bind="attrs" v-on="on">미리보기</v-btn>
                    </template>
                </form-preview>
                <v-btn color="primary" v-bind="{ loading }" @click="save"> 저장하기 </v-btn>
            </v-card-actions> -->
            <v-fade-transition>
                <v-overlay v-show="loading" light color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import getGeolocation from "@/plugins/getGeolocation";
import { initRecruitment, WAGE_TYPES, WORK_EXPERIENCES } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import FormPreview from "./form-preview.vue";
import FormBaseinfo from "./form-baseinfo.vue";
import FormQuestions from "./form-questions.vue";
import FormRecruiter from "./form-recruiter.vue";
import FormEmployment from "./form-employment.vue";
import FormQualification from "./form-qualification.vue";

const RECRUITMENT_FORM_SECTIONS = {
    BASEINFO: { text: "기본정보", value: "BASEINFO" },
    EMPLOYMENT: { text: "근무환경", value: "EMPLOYMENT" },
    QUALIFICATION: { text: "지원자격", value: "QUALIFICATION" },
    RECRUITER: { text: "채용담당자", value: "RECRUITER" },
    QUESTIONS: { text: "추가질문", value: "QUESTIONS" },
};

const sections = Object.values(RECRUITMENT_FORM_SECTIONS);
const section__initial = 0;

export default {
    components: {
        BottomSheet,
        FormPreview,
        FormBaseinfo,
        FormQuestions,
        FormRecruiter,
        FormEmployment,
        FormQualification,
    },
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        form: initRecruitment(),
        hashTags: [],
        sections,

        shows: false,
        loading: false,
        section: section__initial,
        RECRUITMENT_FORM_SECTIONS,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },

        title() {
            let title = "채용공고 ";
            title += this.isCreate ? "등록하기" : "수정하기";
            return title;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                this.step = section__initial;

                if (this.isCreate) {
                    this.form = initRecruitment();
                } else {
                    let { recruitment } = await api.v1.company.recruitments.get({ _id: this.value?._id });

                    if (recruitment?.application?.startsAt) recruitment.application.startsAt = recruitment.application.startsAt.toDate();
                    if (recruitment?.application?.endsAt) recruitment.application.endsAt = recruitment.application.endsAt.toDateTime();

                    if (recruitment?.employment?.startsAt) recruitment.employment.startsAt = recruitment.employment.startsAt.toDate();
                    if (recruitment?.employment?.endsAt) recruitment.employment.endsAt = recruitment.employment.endsAt.toDate();
                    recruitment.questions = (recruitment.questions || []).map((item) => ({ ...item, tempId: Math.random() }));

                    this.form = initRecruitment(recruitment);
                }
                this.hashTags = (await api.v1.setting.get())?.setting?.hashTags || [];
            } finally {
                this.loading = false;
            }
        },

        validate() {
            try {
                ////////////////////////////////////////////////////////////////
                // 기본정보
                ////////////////////////////////////////////////////////////////
                if (!this.form.subject) throw new Error("기본정보 - 제목을 입력하세요");
                if (!this.form.content) throw new Error("기본정보 - 상세를 입력하세요");

                const { isOpenHiring, startsAt, endsAt } = this.form.application;
                const isApplicationFilled = isOpenHiring || (startsAt && endsAt);
                if (!isApplicationFilled) {
                    if (startsAt && !endsAt) throw new Error("기본정보 - 접수기간 종료일시가 입력되지 않았습니다");
                    if (!startsAt && endsAt) throw new Error("기본정보 - 접수기간 시작일자가 입력되지 않았습니다");

                    throw new Error("기본정보 - 접수기간을 입력해주세요");
                }

                ////////////////////////////////////////////////////////////////
                // 근무환경
                ////////////////////////////////////////////////////////////////
                if (!this.form.employment.types.length) throw new Error("근무환경 - 근무유형을 선택하세요");
                if (!this.form.employment.place.address2) throw new Error("근무환경 - 근무지를 입력하세요");
                if (!this.form.employment.wage?.type) throw new Error("근무환경 - 급여 유형을 선택하세요");
                switch (this.form.employment.wage.type) {
                    case undefined:
                    case null: {
                        throw new Error("근무환경 - 급여 유형을 선택하세요");
                    }
                    case WAGE_TYPES.HOURLY.value:
                    case WAGE_TYPES.DAILY.value:
                    case WAGE_TYPES.WEEKLY.value:
                    case WAGE_TYPES.MONTHLY.value:
                    case WAGE_TYPES.YEARLY.value:
                    case WAGE_TYPES.PER_CASE.value: {
                        if (!this.form.employment.wage.value__min) throw new Error("근무환경 - 급여 최소금액이 입력되지 않았습니다");
                        if (!this.form.employment.wage.value__max) throw new Error("근무환경 - 급여 최소금액이 입력되지 않았습니다");
                    }
                }

                ////////////////////////////////////////////////////////////////
                // 지원자격
                ////////////////////////////////////////////////////////////////
                const hasNoWorkExperienceSelected = !this.form.qualification.workExperience.items.length;
                const isWorkExperienceNotIrrelevant = !this.form.qualification.workExperience.isIrrelevant;
                if (hasNoWorkExperienceSelected && isWorkExperienceNotIrrelevant) throw new Error("지원자격 - 경력을 입력하세요");

                const hasWorkExperienced = this.form.qualification.workExperience.items.includes(WORK_EXPERIENCES.EXPERIENCED.value);
                if (hasWorkExperienced) {
                    const yearsNotFilled = !+this.form.qualification.workExperience.years;
                    const monthsNotFilled = !+this.form.qualification.workExperience.months;
                    if (yearsNotFilled && monthsNotFilled) throw new Error("지원자격 - 경력 기간을 입력하세요");
                }

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { post, put } = api.v1.company.recruitments;

                let { _questions = [], questions = [], _attachments = [], attachments = [], ...form } = this.form;
                if (form.employment.place.address1) {
                    form.employment.place.geolocation = await getGeolocation(form.employment.place.address1);
                }

                let { recruitment } = await (this.isCreate ? post : put)(form);

                _questions = await Promise.all(
                    questions.map(async (question) => {
                        question._recruitment = recruitment._id;
                        const isCreate = !question?._id;
                        let { post, put } = api.v1.company.recruitments.questions;
                        return (await (isCreate ? post : put)(question))?.question?._id;
                    })
                );

                // 첨부파일 처리
                for (let [index, item] of (attachments || []).entries()) {
                    if (item instanceof File) {
                        attachments[index] = (await api.v1.me.files.post({ index: `${recruitment?._id}-recruitment-files-${index}` }, item))?.file;
                    }
                }
                const _attachments__toDelete = (_attachments || []).filter((_attachment) => !(attachments || []).some(({ _id }) => _id == _attachment));
                for (const _id of _attachments__toDelete) {
                    await api.v1.me.files.delete({ _id });
                }
                _attachments = (attachments || []).map(({ _id }) => _id);

                recruitment = (await put({ _id: recruitment._id, _questions, _attachments }))?.recruitment;

                this.$emit("input", recruitment);

                alert(this.isCreate ? "등록되었습니다" : "수정되었습니다");
                this.shows = false;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        emit() {
            this.form = initRecruitment(this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
    .v-expansion-panel--active > .v-expansion-panel-header,
    .v-expansion-panel-header {
        min-height: 0;
    }
    .v-expansion-panel-header {
        color: #999;
        padding: 0;
        .v-icon.v-icon {
            color: #999;
        }
    }
    .v-expansion-panel--active > .v-expansion-panel-header {
        color: #131313;
        .primary--active {
            color: var(--v-primary-base);
        }
        .v-icon.v-icon {
            color: var(--v-primary-base);
        }
    }
    .v-expansion-panel-content__wrap {
        padding: 16px 0 0 0;
    }
}
</style>
